import { render, staticRenderFns } from "./FeedbackThread.vue?vue&type=template&id=bbd1af3c&scoped=true"
import script from "./FeedbackThread.vue?vue&type=script&lang=js"
export * from "./FeedbackThread.vue?vue&type=script&lang=js"
import style0 from "./FeedbackThread.vue?vue&type=style&index=0&id=bbd1af3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd1af3c",
  null
  
)

export default component.exports